import { useMutation } from '@apollo/client';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated/gql';
import { adminToasts } from '../../toasts/toasts';
import { UIActions } from '../../ui/uiSlice';

const REQUEST_INTEGRATION = gql(/** @complexity 2 */ `
  mutation trackPlatformRequest($properties: TrackProperties!) {
    track(event: REQUEST_INTEGRATION, properties: $properties)
  }
`);

const useRequestIntegrationMutation = () => {
  const dispatch = useAppDispatch();
  const [requestIntegration] = useMutation(REQUEST_INTEGRATION);

  const request = async (label: string, website: string, detail: string) => {
    const requested = await requestIntegration({
      variables: { properties: { label, website, detail } },
    });
    if (requested) {
      dispatch(UIActions.pushToast(adminToasts.integrationRequestSuccess));
      return true;
    }
    dispatch(UIActions.pushToast(adminToasts.integrationRequestError));
    return false;
  };

  return request;
};

export default useRequestIntegrationMutation;
